export const strengthsData = [
  { value: "Clinical Expertise", label: "Clinical Expertise" },
  {
    value: "Critical Thinking and Problem Solving",
    label: "Critical Thinking and Problem Solving",
  },
  {
    value: "Compassion and Empathy",
    label: "Compassion and Empathy",
  },
  {
    value: "Communication Skills",
    label: "Communication Skills",
  },
  { value: "Team Collaboration", label: "Team Collaboration" },
  {
    value: "Resilience and Stress Management",
    label: "Resilience and Stress Management",
  },
  { value: "Adaptability", label: "Adaptability" },
  { value: "Attention to Detail", label: "Attention to Detail" },
  { value: "Time Management", label: "Time Management" },
  { value: "Leadership", label: "Leadership" },
  { value: "Continual Learning", label: "Continual Learning" },
  { value: "Ethical Judgment", label: "Ethical Judgment" },
  { value: "Patient Advocacy", label: "Patient Advocacy" },
];
